import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import { distinctUntilChanged } from "rxjs/operators";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { EventoDTO } from "../dto/eventoDTO";

@Injectable({
  providedIn: "root"
})
export class EventiStore {


  private eventi: BehaviorSubject<EventoDTO> = new BehaviorSubject<EventoDTO>(null);

  public getEventi(): Observable<EventoDTO> {
    return this.eventi.asObservable().pipe(distinctUntilChanged());
  }

  public pushEvento(evento: EventoDTO) {
    this.eventi.next(evento);
  }
}
